import createAPI from '../axios'
//出勤签到
const attendanceStatisticsSkillsTraining = {
    attendanceStatistics: {
        findAttendanceStatisticsNew: config => createAPI('/AttendanceStatisticsSkillsTrainingController/findAttendanceStatisticsNew', 'post', config),
        findStudentByTeacherClass: config => createAPI('/AttendanceStatisticsSkillsTrainingController/findStudentByTeacherClass', 'post', config),
        saveMessage: config => createAPI('/AttendanceStatisticsSkillsTrainingController/saveMessage', 'post', config),
    }
}

export default attendanceStatisticsSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/attendanceStatisticsSkillsTraining.js